<ideal-editable-row-list-view
  [items]="lengths()"
  (itemsChange)="lengthsChange.emit($event)"
  [sortingDataAccessor]="sortAccessor"
  [trackBy]="trackByLength"
>
  <!-- <ng-template editableListHeader>
    <div class="header">
      <div class="col col-length" mat-sort-header="length">Length</div>
      <div class="col col-qty" mat-sort-header="quantity">Qty</div>
    </div>
  </ng-template> -->

  <ng-template editableListRow let-ctrl let-list="list" let-conflicted="conflicted" let-index="index" let-even="even">
    <div
      class="row row-edit"
      (focusin)="handleRowFocusChange(index, true)"
      (focusout)="handleRowFocusChange(index, false)"
      [class.even]="even"
      [class.odd]="!even"
    >
      <div class="edit">
        <ideal-wire-cut-custom-length
          #rowComponent
          [itemId]="itemId()"
          [formControl]="ctrl"
          [conflicted]="conflicted"
          [mode]="'edit'"
          (quantityEnter)="handleRowQuantityEnter(index)"
          (deleteRequested)="handleRemove(ctrl, list)"
        />
      </div>
      <ideal-drawer position="top" [open]="conflicted || focusedRowIndex() === index">
        <div class="drawer-content" [class.conflicted]="conflicted">
          <div class="conflict-error">Duplicate length</div>

          <div class="actions">
            <div class="action">
              <button mat-stroked-button type="button" (click)="handleRemove(ctrl, list)" [disabled]="!ctrl?.valid || !ctrl?.value">
                <mat-icon>delete</mat-icon> Remove
              </button>
              <div class="conflict-msg">Total: {{ getValidRowQuantity(index) }}</div>
            </div>
            @if (conflicted) {
              <div class="action">
                <button mat-stroked-button type="button" (click)="handleMerge(index, list)" [disabled]="!ctrl?.valid || !ctrl?.value">
                  <mat-icon>merge</mat-icon> Combine
                </button>
                <div class="conflict-msg">New total: {{ getMergedQuantity(index) }}</div>
              </div>
            }
          </div>
        </div>
      </ideal-drawer>
    </div>
  </ng-template>

  <ng-template editableListAddRow let-ctrl let-list="list" let-conflicted="conflicted">
    <div class="row row-add" (focusin)="handleAddRowFocusChange(true)" (focusout)="handleAddRowBlur(ctrl, list, addRowComponent)">
      <div class="edit">
        <ideal-wire-cut-custom-length
          #addRowComponent
          [itemId]="itemId()"
          [formControl]="ctrl"
          [conflicted]="conflicted"
          [mode]="'add'"
          (quantityEnter)="conflicted || handleAddRowQuantityEnter()"
        />
      </div>
      <ideal-drawer position="top" [open]="showAddRowActions()">
        <div class="actions">
          <button
            mat-stroked-button
            type="button"
            (click)="handleAdd(ctrl, list, addRowComponent)"
            [disabled]="conflicted || !ctrl.valid || !ctrl.value"
          >
            <mat-icon>add</mat-icon> Add
          </button>
          @if (conflicted) {
            <button
              mat-stroked-button
              type="button"
              (click)="handleMerge(ctrl, list, addRowComponent)"
              [disabled]="!ctrl.valid || !ctrl.value"
            >
              <mat-icon>merge</mat-icon> Merge
            </button>
          }
        </div>
      </ideal-drawer>
    </div>
  </ng-template>
</ideal-editable-row-list-view>
